var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgViewactivity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10.435,
    viewBox: "0 0 12 10.435",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icn_viewactivity",
    d: "M120.98-790.706v-.94h-1.926a.947.947,0,0,1-.695-.288.947.947,0,0,1-.288-.695v-5.2h-2.127v.94a.767.767,0,0,1-.231.563.767.767,0,0,1-.563.231h-1.893a.766.766,0,0,1-.563-.232.769.769,0,0,1-.231-.564v-2.665a.759.759,0,0,1,.231-.561.771.771,0,0,1,.563-.229h1.893a.767.767,0,0,1,.563.231.767.767,0,0,1,.231.563v.94h5.036v-.943a.761.761,0,0,1,.231-.563.771.771,0,0,1,.563-.229h1.893a.766.766,0,0,1,.563.232.768.768,0,0,1,.231.564v2.665a.759.759,0,0,1-.231.561.771.771,0,0,1-.563.229h-1.893a.767.767,0,0,1-.563-.231.767.767,0,0,1-.231-.563v-.94h-2.127v5.2a.2.2,0,0,0,.056.144.2.2,0,0,0,.144.056h1.926v-.943a.761.761,0,0,1,.231-.563.771.771,0,0,1,.563-.229h1.893a.766.766,0,0,1,.563.232.769.769,0,0,1,.231.564v2.665a.759.759,0,0,1-.231.561.771.771,0,0,1-.563.229h-1.893a.767.767,0,0,1-.563-.231A.767.767,0,0,1,120.98-790.706Zm-7.736-8.858v0Zm8.518,6.183v0Zm0-6.183v0Zm0,2.688h1.918v-2.688h-1.918Zm0,6.183h1.918v-2.687h-1.918Zm-8.518-6.183h1.918v-2.688h-1.918Z",
    transform: "translate(-112.462 800.346)",
    fill: "#3b3b3b"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewactivity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/viewactivity.ef889383.svg";
export { ForwardRef as ReactComponent };